export const CLIENT_EBOX_LOCATION_BUTTON_ID = 'client-cars-show';
export const CLIENT_EBOX_LOCATION_MORE_DETAILS_BUTTON_ID = 'client-cars-more-details-show';

export const SECURE_EBOX_POPOVER_ID = 'client-cars-modal';

export const CAR_CLUSTER_MIN_POINTS = 2;
